module.exports = __webpack_public_path__ + "static/media/caros-bold-italic.29f21477.woff";